module.exports = __webpack_public_path__ + "img/Grend.53329403.svg";